import { useReadContract, useWriteContract, useWaitForTransactionReceipt } from "wagmi";
import { getContractAddress, USDTABI } from "@/lib/contracts";

// Get USDT balance for an address
export function useUSDTBalance(address: `0x${string}` | undefined) {
  return useReadContract({
    address: getContractAddress("USDT") as `0x${string}`,
    abi: USDTABI,
    functionName: "balanceOf",
    args: address ? [address] : undefined,
    query: {
      enabled: !!address,
      refetchInterval: 10000,
    },
  });
}

// Get USDT allowance for a spender
export function useUSDTAllowance(
  owner: `0x${string}` | undefined,
  spender: `0x${string}` | undefined
) {
  return useReadContract({
    address: getContractAddress("USDT") as `0x${string}`,
    abi: USDTABI,
    functionName: "allowance",
    args: owner && spender ? [owner, spender] : undefined,
    query: {
      enabled: !!owner && !!spender,
      refetchInterval: 5000,
    },
  });
}

// Hook for approving USDT spending
export function useUSDTApprove() {
  const { writeContract, data: hash, isPending, error } = useWriteContract();

  const { isLoading: isConfirming, isSuccess } = useWaitForTransactionReceipt({
    hash,
  });

  const approve = (spender: `0x${string}`, amount: bigint) => {
    writeContract({
      address: getContractAddress("USDT") as `0x${string}`,
      abi: USDTABI,
      functionName: "approve",
      args: [spender, amount],
    });
  };

  return {
    approve,
    hash,
    isPending,
    isConfirming,
    isSuccess,
    error,
  };
}
